export const getFilteredValue = (items: unknown[], value: string) => {
  return items.filter(item => item.name.toLowerCase().includes(value));
};
